import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { AnalyticsCoreURLService } from '../../../reporting/analytics-core/services/analytics-core.url.service';

@Injectable()
export class RedirectGuard implements CanActivate {
	constructor(
		private storageSessionService: StorageSessionService,
		private router: Router,
		private authService: AuthService,
		private analyticsCoreURLService: AnalyticsCoreURLService
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return new Promise((resolve) => {
			const accessToken = next.params['aTkn'];
			this.authService.verifySSOAccessToken(accessToken).subscribe((response: any) => {
				this.storageSessionService.queryParams = window.location.search;
				this.storageSessionService.reloadDataAfterLogin = true;
				const queryParamsObj = this.storageSessionService.getQueryParamsObj();
				if (response.success) {
					this.analyticsCoreURLService.updateServiceURLForPartnerCNAME(response.partner_domain);
					if (state.url.indexOf('redirect') !== -1) {
						let nextRoute = '/dashboard';
						if (queryParamsObj['product']) {
							nextRoute = `${nextRoute}/${queryParamsObj['product']}`;
							delete queryParamsObj['product'];
						}
						this.router.navigate([nextRoute], { queryParams: queryParamsObj });
						resolve(false);
					} else {
						resolve(true);
					}
				} else {
					if (state.url.indexOf('redirect') !== -1) {
						this.router.navigate(['/login'], { queryParams: queryParamsObj });
						resolve(false);
					} else {
						resolve(true);
					}
				}
			});
		});
	}
}
